import {checkoutLogin} from "@/utils/RoutesBeforeUtils";

const IndexRoutes = [
    {
        path: '/',
        name: 'Index',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/cn',
        name: 'IndexCN',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/en',
        name: 'IndexEN',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/es',
        name: 'IndexES',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/br',
        name: 'IndexBR',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/de',
        name: 'IndexDE',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/fr',
        name: 'IndexFR',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/it',
        name: 'IndexIT',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/jp',
        name: 'IndexJP',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/ko',
        name: 'IndexKO',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    {
        path: '/ru',
        name: 'IndexRU',
        component: () => import(/* webpackChunkName: "index" */'@/views/index/Index.vue')
    },
    // 多语言首页 end
    {
        path: '/order',
        name: 'Order',
        component: () => import(/* webpackChunkName: "order" */'@/views/order/Order.vue'),
        beforeEnter: checkoutLogin
    },
    {
        path: '/logout',
        name: 'LogOut',
        component: () => import(/* webpackChunkName: "logout" */'@/views/logout/LogOut.vue')
    }
];

export default IndexRoutes;
